import VueAwesomeIcon from 'vue-awesome/components/Icon';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';

import { loadThreeflowComponents, threeflowObject } from './shared';

// styles
import './assets/styles/main.scss';
import './assets/styles/examples.scss';

// icons
import 'vue-awesome/icons/angle-left';
import 'vue-awesome/icons/angle-right';
import 'vue-awesome/icons/angle-up';
import 'vue-awesome/icons/arrow-left';
import 'vue-awesome/icons/arrow-up';
import 'vue-awesome/icons/bars';
import 'vue-awesome/icons/caret-down';
import 'vue-awesome/icons/caret-up';
import 'vue-awesome/icons/check';
import 'vue-awesome/icons/check-circle';
import 'vue-awesome/icons/check-square';
import 'vue-awesome/icons/chevron-down';
import 'vue-awesome/icons/circle';
import 'vue-awesome/icons/dot-circle';
import 'vue-awesome/icons/download';
import 'vue-awesome/icons/edit';
import 'vue-awesome/icons/ellipsis-v';
import 'vue-awesome/icons/exclamation-triangle';
import 'vue-awesome/icons/eye';
import 'vue-awesome/icons/file';
import 'vue-awesome/icons/file-upload';
import 'vue-awesome/icons/file-download';
import 'vue-awesome/icons/file-code';
import 'vue-awesome/icons/question-circle';
import 'vue-awesome/icons/minus';
import 'vue-awesome/icons/pencil-alt';
import 'vue-awesome/icons/plus';
import 'vue-awesome/icons/random';
import 'vue-awesome/icons/regular/calendar-alt';
import 'vue-awesome/icons/reply';
import 'vue-awesome/icons/search';
import 'vue-awesome/icons/share';
import 'vue-awesome/icons/spinner';
import 'vue-awesome/icons/square';
import 'vue-awesome/icons/times';
import 'vue-awesome/icons/trash-alt';
import 'vue-awesome/icons/upload';

import ExampleMenuItem from './components/ExampleMenuItem';

Vue.component('ExampleMenuItem', ExampleMenuItem);

Vue.config.productionTip = false;
Vue.component('Icon', VueAwesomeIcon);
Object.defineProperty(Vue.prototype, '$TF', { value: threeflowObject });
loadThreeflowComponents(Vue);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
